"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Dropdown = _interopRequireDefault(require("../../Dropdown/Dropdown"));

var _Avatar = _interopRequireDefault(require("../../Avatar/Avatar"));

var _status = require("../../../constants/status");

var _UserItem = require("./UserItem.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// otherProps are for Dropdown
var UserItem = function UserItem(_ref) {
  var className = _ref.className,
      menu = _ref.menu,
      avatar = _ref.avatar,
      userName = _ref.userName,
      status = _ref.status,
      bgColor = _ref.bgColor,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["className", "menu", "avatar", "userName", "status", "bgColor"]);
  var statusProp = (0, _react.useMemo)(function () {
    var index = Object.values(_status.ONLINE_STATUS).indexOf(status);
    return Object.keys(_status.ONLINE_STATUS)[index];
  }, [status]);
  return (0, _jsxRuntime.jsx)(_Dropdown["default"], _objectSpread(_objectSpread({
    css: _UserItem.styles.base,
    className: className,
    overlay: menu,
    hasMinWidth: true,
    autoHeight: true,
    menuItemIconHidden: true
  }, otherProps), {}, {
    children: (0, _jsxRuntime.jsx)(_Avatar["default"], {
      className: "grui cursor-pointer relative",
      avatar: avatar,
      userName: userName,
      size: "xl",
      borderRadius: 4,
      bgColor: bgColor,
      css: statusProp && _UserItem.styles.statuses[statusProp]
    })
  }));
};

UserItem.propTypes = {
  className: _propTypes.string,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    key: _propTypes.string,
    title: _propTypes.string
  })),
  avatar: _propTypes.string,

  /**
   * Username for showing initials in avatar when there is no picture
   */
  userName: _propTypes.string,

  /**
   * Background for avatar when there is no picture
   */
  bgColor: _propTypes.string,
  menu: _propTypes.node,
  status: (0, _propTypes.oneOf)(Object.values(_status.ONLINE_STATUS))
};
UserItem.defaultProps = {
  className: undefined,
  options: [],
  avatar: undefined,
  userName: '',
  bgColor: undefined,
  menu: undefined,
  status: _status.ONLINE_STATUS.offline
};
var _default = UserItem;
exports["default"] = _default;
//# sourceMappingURL=UserItem.js.map